module.exports = __webpack_public_path__ + "static/img/japan.e0d8cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/japan.jpg
// module id = 1viU
// module chunks = 1